export const EngLocalizedStrings = {
  GlobalLabels: {
    VersionNumber: "1.1.2",
    Other: "Other",
    Store: "Store",
    Staff: "Staff",
    Code: "Code",
    Welcome: "Login to CMS",
    Balance: "Balance",
    Authorize: "Authorization",
    Carrier: "Internet Service Provider",
    Currency: "Currency",
    Topup: "Add balance",
    Close: "Close",
    All: "All",
    STT: "No.",
    NoSort: "None",
    Status: "Status",
    Phone: "Phone Number",
    Noti: "Notification",
    Actions: "Actions",
    Active: "Active",
    Position: "Position",
    Inactive: "Inactive",
    Deleted: "Delete",
    Search: "Search",
    Redo: "Refresh Filter",
    Cancel: "Cancel",
    Error: "Something is error. Please try again",
    TakePicture: "Take picture",
    Confirmed: "Confirm",
    Detail: "Details",
    Create: "Add new",
    Password: "Password",
    NewPassword: "New password",
    PasswordConfirmed: "Confirm password",
    Description: "Description",
    Update: "Update",
    Address: "Address",
    Partner: "Partner",
    PartnerCode: "Partner Code",
    Total: "Total",
    NoPartner: "Not a partner",
    createdAt: "Created Date",
    updatedAt: "Updated Date",
    Cover: "Background image",
    Success: "Success",
    Failed: "Failed",
    Date: "Date",
    Week: "Week",
    Month: "Month",
    Hour: "Hour",
    ExcelExporting: "Export Excel",
    Type: "Type",
    Name: "Name",
    Fullname: "Full name",
    Regions: "Region",
    Login: "Login",
    NoInfo: "No information",
    ASC: "Ascending",
    DESC: "Descending",
    Logout: "Logout",
    Attention: "See notes here",
    ReloadImages: "Refresh image",
    DownloadImage: "Download image",
    DownloadZip: "Download zip file",
    Placeholder: "Import",
    Choose: "Select",
    Images: "Image",
    UserName: "Username",
    Email: "Email",
    Order: "STT",
    Loading: "Loading...",
    Time: "Time",
    Yes: "Yes",
    No: "No",
    Download: "Download",
    User: "User",
    Config: "Configuration",
    Save: "Save",
    Edit: "Edit",
    Supplier: "Supplier",
    SupplierType: "NCC Type",
    Import: "Import",
    ChangeStatus: "Change status",
    AccountManagement: "Account management",
    ResetPassword: "Reset password",
    Tools: "Tools",
    Reason: "Reason",
    RefreshFeature: "Refresh permission data",
    GeneralInfo: "General Info",
  },
  GlobalMessage: {
    RightClickCopy: "Right click to copy",
    ApproveAksing: "Do you want to approve this element ?",
    Email: "Enter the correct Email format!",
    UpdateSuccessfully: "Updated successfully!",
    UpdateFailed: "Updated failed:",
    CreateSuccessfully: "Created successfully!",
    CreateFailed: "Created failed:",
    DeleteSuccessfully: "Delete successfully!",
    DeleteFailed: "Delete failed:",
    DeleteConfirmation: "Confirm deleting this element?",
    DeleteConfirmationWithName: 'Do you want to delete "{name}"?',
    ResetPassSuccessfully: "Reset password successfully!",
    ResetPassFailed: "Reset password failed:",
    Error: "An error occurred",
    Exporting: "Exporting Report...",
    SystemError:
      "Error retrieving login information or expired token, returning to login page...",
    LoginSuccessfully: "Login successfully!",
    InvalidAccount: "Invalid username or password or User does not exist!",
    InvalidMenuConfig: "Error in getting Sidebar Menu, please try again later!",
    Supplier: "Please enter Reference Code",
    ChooseSupplier: "Please select Supplier",
    Required: "Please enter this information",
    CannotAccessCam: "Cannot access camera",
    SavingForLogin: "Keep me logged in",
    SavedToClipboard: "Saved value to clipboard.",
    InvalidStore: "Choose a specific store",
    InvalidToken: "Token is invalid or removed, directing to Login...",
    PasswordNotMatch: "Password does not match",
    PasswordLength: "Password needs to be at least 6 characters",
    ResetPassMessage: "Do you want to change password for this user?",
    SyncOnProcess: "Syncing data, please wait...",
    NotAllowedToUse: "Need to be authorized",
    RefreshFeatureSuccessfully:
      "Permission data of your account has been refreshed !",
    NotFoundPath: "Not found path or unable to access api",
    AlreadyHasCopied: "This value has been saved",
    ResetOTPMessage: "Do you want to reset OTP for this user?",
    SearchPlaceholder: "Enter keywords to search",
    ExcelError: "Error with files: Wrong formats or invalid data",
    NeedPermisson: "Your permisson to read clipboard must be granted",
    PermissonSuccess: "Permisson to read clipboard has been granted",
    SignUp: "Sign up account",
    Url: "Enter value following the URL format",
    PositiveNumber: "Enter the value from 0...",
    Currency: "Enter the money at least 1,000 VND...",
    PleaseWait: "Please wait a moment...",
  },
  GlobalPlaceholder: {
    UserName: "Enter user name",
    Currency: "Select currency",
    Email: "Please enter email...",
    Name: "Please enter name...",
    Code: "Please enter code...",
    Partner: "Please select partner",
    Status: "Please select status",
    Phone: "Please enter phone number...",
    Password: "Enter password",
    PasswordConfirmed: "The confirmation password must match the password",
    Description: "Please enter description in text",
    Type: "Please select type",
  },
  GlobalTotalSummary: {
    Success: "Success",
    Error: "Failed",
    Other: "Others",
    USD: "Foreign Revenue",
    VND: "Domestic Revenue",
    Revenue: "Total revenue",
  },
  GlobalService: {
    SIM_ECOMMERCE: "SIM",
    TRAVEL_SIM: "Travel SIM",
    NICE_SIM: "Nice SIM",
    BUY_PACKAGE: "Mobile Plan",
    AIR_TIME: "Top up phone",
    ALL: "All",
  },
  Role: {
    SuperAdmin: "Super Admin",
    Admin: "Admin",
    Accountant: "Accountant",
    User: "User",
  },
  TopupInfo: {
    Company: "CTY CP CONG NGHE VA TRUYEN THONG KY NGUYEN MOI",
    AccountNumber: "1059433547",
    SwiftCode: "BFTVVNVX042",
    Title: "Bank Transfer Information",
    AccountName: "Account Name",
    AccountNo: "Account Number",
    Bank: "Bank",
    BankName: "Joint Stock Commercial Bank for Foreign Trade of Vietnam",
    BankAddress:
      "No.664 Su Van Hanh Street, Hoa Hung Ward, Ho Chi Minh City, Viet Nam",
    BankBranch: "Thu Thiem Branch, Cao Thang Transaction Office",
  },
  Sidebar: {
    General: "Overview",
    Management: "Management",
    History: "Transaction History",
    DataTransaction: "Package",
    SystemConfig: "System Configuration",
    DataPackages: "Data Package",
    RoamingPackages: "Roaming Package",
    UserManagement: "User",
    AffiliateManagement: "Affiliate Management",
    OrderList: "SIM Purchase Order",
    TravelSimList: "Travel SIM Registration",
    Country: "Country",
    PlatformConfig: "Platform",
    Contents: "Article",
    Files: "File",
    CDN: "CDN",
    Address: "Province",
    TopUpForPackage: "Package 4G/5G",
    TopupForSimEcommerce: "Mobifone SIM Package",
    TopUpForTravelService: "Travel SIM Package",
    Suppliers: "Supplier",
    RegisterHistory: "Register History",
  },
  General: {
    Title: "Overview",
    Summary: "Business activity summary",
    ByDate: "By Date",
    ByWeek: "By Week",
    ByMonth: "By Month",
    ByCurrency: "In Currency",
    Revenue: {
      Label: "Revenue",
      CompareWith: "compared to",
      Transaction: "Quantity",
      CurrentDate: "today",
      CurrentMonth: "this month",
      LastMonth: "last month",
      PreviousDate: "yesterday",
      LastMonthDate: "last month",
      LastMonthBefore: "last month before",
      Day: "Today's Revenue",
      Week: "This Week's Revenue",
      Month: "This Month's Revenue",
      WeekOfYear: "Week",
    },
    Charts: {
      Title: "Summary Report",
      Transaction: "Transaction",
      TotalRevenue: "Total Revenue",
      SuccessTransaction: "Total Successful Transactions",
    },
  },
  ErrorCodeGeneral: {
    Title: "Error Statistics",
    List: "Error Code List",
    LongMessage: "Description: ",
    Summary: "Business Error Statistics",
    ByDate: "By Day",
    ByWeek: "By Week",
    ByMonth: "By Month",
    Tab: {
      0: "Error Code",
      1: "Product",
      2: "Network Operator",
    },
    Transaction: {
      Label: "Error Output",
      CompareWith: "compared to",
      CurrentDate: "today",
      CurrentMonth: "this month",
      LastMonth: "previous month",
      PreviousDate: "yesterday",
      LastMonthDate: "last month",
      Day: "Today's Output",
      Week: "This Week's Output",
      Month: "This Month's Output",
      WeekOfYear: "Week",
    },
  },
  UserManagement: {
    MainTitle: "System User",
    B2CTitle: "B2C's Users",
    B2BTitle: "B2B's Users",
    Total: "Total User",
    UserType: {
      Agency: "Agency's User",
      Store: "Store's User",
      Employee: "Employee",
    },
    AllType: {
      0: "Normal",
      1: "Super Admin",
      3: "Chain",
      4: "Store",
      5: "Staff",
      6: "Anonymous",
    },
    StaffColumns: {
      name: "Name",
      fullName: "Full name",
      code: "Code",
      phone: "Phone number",
      email: "Email",
      address: "Address",
      store: "Store",
      partner: "Partner",
      parent: "Employee of",
      wallet: "Current Balance (VND)",
      type: "Type",
      platform: "Platform",
      status: "Status",
      createdAt: "Created At",
    },
    B2CUserCreate: {
      userName: "Username",
      name: "Name",
      email: "Email",
      fullName: "Full Name",
      birthDay: "Birthday",
      phone: "Phone",
      type: "Type",
      status: "Status",
      partner: "Partner",
      parent: "Belongs To User ?",
      stores: "Stores",
      platform: "Platform",
      role: "Role",
      avatar: "Avatar",
      confirmPayment: "Confirm Payment ?",
      taxCode: "Tax Code",
      isVerified: "Is Verified ?",
    },
    Columns: {
      UserName: "Username",
      FullName: "Full Name",
      Email: "Email",
      Partner: "Partner",
      Phone: "Phone Number",
      Balance: "Balance",
      Role: "Role user",
      ResetPass: "Set new password",
      OldPass: "Old password",
      NewPass: "New password",
      UpdateStatus: "Update Status",
      CreatedAt: "Created at",
      Code: "Code",
      Referents: "Providers",
    },
    RuleMessage: {
      Url: "Please enter the link as HTTPS URL",
      Name: "Please enter the name",
      Password: "Please enter the password",
      UserName: "Please enter the username",
      IdUrl: "Please enter the marketing link",
      IconUrl: "Please enter the icon link in jpg, png, jpeg format",
      Status: "Please select the status",
      Phone: "Please enter the 10-digit phone number",
      Code: "Please enter the code",
      Role: "Please select the role for the user",
      Partner: "Please select the partner (optional)",
      InvalidPartner: "Invalid partner",
      Balance: "Please enter the limit",
      InvalidUserStore: "Select a Store's user",
      InvalidUserChain: "Select a Chain's user",
      InvalidReference: "Select a provider",
    },
    Labels: {
      Account: "Account",
      Address: "Address",
      Note: "Note",
      Description: "Description",
      UserFeatures: "Custom features for user",
    },
  },
  UserFeatures: {
    Title: "User features",
    Columns: {
      Name: "Name",
      Code: "Code",
      Path: "API path",
    },
  },
  PathConfigManagement: {
    Title: "Configuration Management",
    Total: "Total",
    Columns: {
      Title: "Configuration Name",
      Code: "Configuration Code",
      Path: "Path",
      ImageUrl: "Image",
      Description: "Description",
    },
    Placeholder: {
      Title: "Please enter a name",
      Path: "Please enter a path",
      ImageUrl: "Please enter an image URL",
      Description: "Please enter a description",
    },
    Message: {
      AddConfig: "Please declare the JSON configuration below",
    },
  },
  ContentManagement: {
    Title: "Post Management",
    Total: "Total Posts",
    Columns: {
      Name: "Post Name",
      Preview: "Preview",
      Replace: "Replace Posts",
      Download: "Download Posts",
      Delete: "Delete Posts",
      File: "Post File write",
      Image: "Image",
    },
    Message: {
      WrongStructure: "The uploaded file is not in the correct format!",
      NotExisted: "The uploaded file does not exist!",
      Files: "Please enter at least one article file",
      OnlyDocx: "Note: Only enter DOCX files",
      OnlyImages: "Note: Only enter 1 PNG, JPEG, JPG image file",
      MissingAttributes:
        "Please name the article file with the prefix Content for DOC files or Image for image files!",
      AddAttribute:
        "Please name the article file with the prefix Content (Content_abc.docx), the image file with the prefix Image (Image_xyz.png)",
    },
  },
  CountryManagement: {
    Title: "Country Management",
    Total: "Total Countries",
    Columns: {
      Name: "Country Name",
      Code: "Country Code",
      Capital: "Capital",
      Region: "Region",
      Ensign: "Country Flag",
    },
    Regions: {
      Americas: "Americas",
      Europe: "Europe",
      Asia: "Asia",
      Africa: "Africa",
      Oceania: "Oceania",
      Antarctica: "Antarctica",
    },
    Placeholder: {
      Capital: "Please enter the capital name",
      Region: "Please select the country region",
      Cover: "Please enter the image link as URL",
    },
    RoamingPartner: {
      Name: "Partner Name",
      Code: "Partner Code",
    },
    MobileData: {
      Name: "Package Name",
      Code: "Package Code",
      Price: "Package Price",
      Handset: "Handset",
      TransferredData: "Data Group",
      CodeMobileDevice: "Mobile Device Code",
    },
    Message: {
      CoverAttributes: "Please select the cover image file",
      EnsignAttributes: "Please select a flag image file",
      Name: "Enter country name (Ex: Vietnam)",
      Code: "Enter country code",
      Capital: "Enter the capital (Ex: Hanoi)",
      Region: "Select the region",
    },
  },
  FileManagement: {
    Title: "CDN Management",
    Upload: "Import File",
    Replace: "Replace File",
    Download: "Download File",
    CopyUrl: "Copy URL",
    Placeholder: {
      Type: "Please select file type",
      File: "Please import at least 1 file from your computer",
      Url: "Saved URL to clipboard",
      SavedValue: "Saved value to clipboard",
    },
    Columns: {
      Name: "File name",
      Code: "File code",
      Size: "Size",
      Type: "File type",
    },
  },
  RoamingManagement: {
    Title: "Roaming Package Management",
    Total: "Total Roaming Package",
    Add: "Add",
    DetailInfo: "Package Details",
    RoamingPartnerInfo: "Roaming Partner Information",
    Category: {
      Hot: "Hot Package",
      Day: "Day Package",
      Week: "Weekly Package",
      Month: "Monthly Package",
      Roaming: "Roaming Package",
    },
    PlaceHolder: {
      Cover: "Please enter image url...",
      Descriptions: "Please enter description...",
      ShortDes: "Please enter short description...",
      Duration: "Please enter package duration...",
      Price: "Please enter package price...",
      Storage: "Please enter package capacity...",
      DiscountRate: "Please enter discount...",
      InternalCallTotalHour: "Please enter domestic call hours...",
      ExternalCallTotalHour: "Please enter international call hours...",
      Category: "Please select package type...",
      Country: "Please select country...",
    },
    Country: {
      Title: "Country",
      Add: "Add country",
      Edit: "Edit country information",
    },
    RoamingPartner: {
      Title: "Partner",
      Add: "Add Partner",
      Select: "Select Partner",
    },
    Columns: {
      Name: "Package Name",
      Code: "Code",
      Cover: "Image",
      Description: "Description",
      ShortDescription: "ShortDescription",
      Duration: "Package Duration",
      Price: "Price",
      Storage: "Storage",
      DiscountRate: "Discount",
      InternalCallTotalHour: "Internal Call Hours",
      ExternalCallTotalHour: "Outside Call Hours",
      Action: "Action",
      Country: "Country",
      Region: "Region",
      Category: "Package Type",
      Order: "Order",
      Type: "Type",
      SimType: "Sim Type",
      OnlyData: "Data Only",
    },
  },
  TopupManagement: {
    Title: "Data Package Management",
    Total: "Total Package",
    PriceRange: "Price Range",
    Add: "Add Information",
    AddShort: "Add short description",
    AddMore: "Add extended information for the package",
    More: "Extended information for the package",
    MoreInfoName: "Information name",
    MoreInfoItems: "Information",
    ShortDescription: "Short description",
    Order: "By priority",
    OnlyData: "Only Data ?",
    SimType: "Package for SIM ?",
    MoreWithTag: "Package tag",
    TopLeftTitle: "Tag title",
    IsHot: "Is the package HOT ?",
    IsMobileTag: "Does the package have a tag?",
    Generals: "Package information",
    CountryInfo: "Country",
    Columns: {
      Name: "Package name",
      Code: "Package code",
      Order: "Priority",
      DurationDay: "Duration",
      Price: "Package price",
      Storage: "Capacity",
      Category: "Package category",
      InternalCallTotalHour: "Domestic calls",
      ExternalCallTotalHour: "Call outside the network",
    },
    Category: {
      Hot: "Hot package",
      Day: "Day package",
      Week: "Weekly package",
      Month: "Monthly package",
    },
    Placeholder: {
      DurationDay: "Please enter package duration",
      Price: "Please enter the lowest package price of 1,000 VNĐ!",
      Storage: "Please enter the capacity as a number!",
      Cover: "Please enter the link as a URL!",
      Category: "Please select a package type",
      DesAuto:
        "Enter a short description to be able to update the description automatically",
      AutoUpdate: "Update for the whole Description",
      RoamingIsRequired: "Can only access the Country when the Type is Roaming",
      UpdateCountry: "Customize Country information for the Roaming package",
      DuplicatedCode: "This provider's package code already exists",
    },
    SyncFromB2B: {
      Title: "Add data package from B2B",
      Confirm: "Are you sure you want to add packages",
      InvalidPackages: "Please select a package",
    },
    Service: {
      BuyPackage: "Data 4G/5G",
      TravelSim: "Travel SIM",
      SimEcommerce: "Mobifone SIM",
    },
  },
  TransactionHistory: {
    Title: "Package transaction history",
    Total: "Total transactions",
    NoTransRef: "No reference code",
    Customer: "Retail customers",
    Details: "Transaction details",
    StatusCheck: "Check status",
    Message: {
      PartnerListError: "Partner list error",
    },
    Status: {
      Init: "Initialization",
      Progerssing: "Processing",
      Finished: "Completed",
      Error: "Error",
      Deleted: "Deleted",
      WaitingToBeConfirmed: "Waiting for confirmation",
    },
    Placeholder: {
      Code: "Enter transaction code",
      ID: "Enter transaction ID",
      TransRef: "Enter reference code",
    },
    Columns: {
      ID: "Transaction ID",
      Code: "Transaction code",
      TransRef: "Reference code",
      PackageName: "Mobile plan",
      Phone: "Phone number",
      Partner: "Partner",
      Method: "Method",
      TotalAmount: "Total amount",
    },
  },
  AddressManagement: {
    Title: "Province Management",
    DataType: "List data",
    Province: "List of Provinces, Major Cities",
    District: "List of Districts, Counties",
    Wards: "List of Wards, Communes",
    Columns: {
      Name: "Name",
      Code: "Code",
      FullName: "Full name",
      FullNameEn: "Full English name",
      Province: "Province, Major City",
      District: "District, Counties",
      NameEn: "English name",
      Ward: "Ward, Commune",
    },
    Placeholder: {
      Units: "Please select type",
      Regions: "Please select region",
    },
  },
  ChangePassword: {
    Title: "Change password",
    OldPass: "Current password",
    NewPass: "New password",
    Reconfirmed: "Confirm new password",
    Message: {
      InvalidPass: "Please confirm password",
      OldPass: "Please enter old password",
      NewPass: "Please enter new password",
      UnmatchedPass: "Confirmed password does not match",
      ChangePassSucceed: "You have successfully changed your password!",
    },
  },
  SimOrdersForPartners: {
    Title: "List of Sim registration information",
    Columns: {
      CreatedAt: "Creation time",
      OrderCode: "Order code",
      Sim: "Sim number",
      PackageType: "Package type",
      CustomerName: "Customer name",
      CustomerPhone: "Customer phone number",
      Address: "Delivery address",
      Email: "Customer email",
      Partner: "Partner",
    },
    Status: {
      WaitingForPurchased: "Waiting for payment",
      WaitingForDelivered: "Waiting for delivery",
      WaitingForRecieved: "Waiting for receipt",
      Success: "Successfully delivered",
      Canceled: "Cancelled",
      ConnectedSuccessfully: "Connection successful",
      ConnectedFailed: "Connection failed",
    },
    Message: {
      ExcelError: "Error exporting report",
      InvalidSim: "Sim number cannot be blank",
      InvalidPackages: "Enter sim number to display package information",
      InvalidOrderCode: "Order code cannot be blank",
      InvalidPhone:
        "Contact phone number cannot be blank or more than 10 digits!",
      Address: "Please enter customer address",
    },
  },
  TravelSimListManagement: {
    Title: "Travel SIM Registration Information List",
    Placeholder: "Please Enter",
    Detail: "Detailed Information",
    Gender: {
      Male: "Male",
      Female: "Female",
    },
    Labels: {
      Status: "Status",
      Type: "Type",
      Name: "Customer Name",
      ProfileId: "Profile Code",
      Serial: "Serial Number",
      Sim: "Sim Number",
      Detail: "Details",
      Time: "Creation Time",
      IdNumber: "Identification Code",
      Birthday: "Date of Birth",
      Sex: "Gender",
      Address: "Address",
      PlaceOfOrigin: "Hometown",
      IssueDate: "Date of Issue",
      IssuePlace: "Place of Issue",
      PhoneContact: "Phone Number",
      EmailContact: "Email",
      ImagesPath: "Types of Documents",
    },
    ImagePaths: {
      portrait: "Photo portrait",
      front: "Front",
      back: "Back",
      sign: "Signature",
    },
    Status: {
      init: "Initialization",
      isOCR: "OCRed",
      verified: "Verified",
      progress: "Processing",
      success: "Success",
      error: "Failure",
    },
    Type: {
      cccd: "CCCD",
      passport: "Passport",
    },
  },
  RoamingRegistration: {
    Title: "Register for User",
    ModalTitle: "Register for Subscriber",
    Action: "Select Package",
    Phone: "Subscriber to Register",
    Register: "Register",
    AddToList: "Add to Register List",
    AssingedList: "Register List",
    PhoneRegisteredListColumns: {
      Name: "Customer Name",
      Phone: "Registered Subscriber",
      Address: "Address only",
      Price: "Total",
      Email: "Email",
    },
    Columns: {
      Name: "Package name",
      Code: "Package code",
      Type: "Package type",
      Duration: "Duration",
      Capacity: "Capacity",
      Price: "Package price",
      PartnerTransId: "Partner reference code",
    },
    Placehoder: {
      Phone: "Please enter phone number...",
    },
    Message: {
      Success: "Package registration successful",
      Failed: "Package registration for subscriber failed",
      Error: "An error occurred",
      InvalidPackageAndPhone:
        "Please select a package and enter the subscriber to continue!",
      InvalidPackage: "Please select a package!",
      InvalidPhone:
        "Please enter the subscriber number to register for the package!",
      RegisterSuccessfully: "Package registration for subscriber successfully!",
      PhoneRegistrationWarning:
        "This is a reference list, please search with the subscriber number to register to display the list of suitable packages",
      PhoneRegistrationConfirm: "Confirm package registration",
      ForPhone: "for subscribers",
      BasePackagesExisted: "The subscriber to register has a base package",
      RemoveBasePackages:
        "Please cancel the base package before registering a new package!",
      PackagesForSearchedPhone: "List of packages for subscribers",
      NotMobifone:
        "The subscriber does not belong to the Mobifone prefix, please try again!",
      EmptyAssignedList: "The registration list is empty!",
      InvalidPartnerTransId: "Please enter the partner reference code!",
      InvalidPhoneLength: "Please enter a full 10-digit phone number!",
    },
  },
  BalanceHistory: {
    Title: "Balance Adjustment History",
    Approve: "Approve",
    Reject: "Reject",
    Add: "Create Voucher",
    Type: {
      1: "Decrease Voucher",
      2: "Increase Voucher",
      3: "Refund Voucher",
    },
    Status: {
      0: "Pending approval",
      2: "Approved",
      3: "Error",
      9: "Rejected",
    },
    ApplicableType: {
      0: "User",
      1: "Partner",
    },
    Transaction: {
      code: "Transaction Code",
      service: "Service",
    },
    Placeholder: {
      Type: "Please select voucher type",
      ApplicableType: "Please select applicable object",
      Amount: "Please enter the required amount of at least 1000 VNĐ",
      Phone: "Select user or partner to get phone number",
      Partner: "Please select a partner",
      User: "Please select a user",
    },
    Columns: {
      code: "Ticket Code",
      phoneNumber: "Phone Number",
      partnerName: "Partner Name",
      partnerCode: "Partner Code",
      providerCode: "Provider",
      totalPrice: "Requested Amount",
      beforeCredit: "Balance before approval",
      afterCredit: "Balance after approval",
      applicableType: "Applicable Type",
      type: "Type",
      status: "Status",
      createdBy: "Created By",
      updatedBy: "Updated By",
      name: "Reason",
      createdAt: "Created Date",
      updatedAt: "Updated Date",
    },
    Message: {
      CreateSuccessfully: "Voucher creation successful!",
      CreateFailed: "Voucher creation failed!",
      ApproveSuccessfully: "Voucher approval successful!",
      ApproveFailed: "Voucher approval failed",
      RejectSuccessfully: "Voucher rejection successful!",
      RejectFailed: "Voucher rejection failed",
      ConfirmedReject: "Confirm the rejection of the ticket ?",
      ConfirmApprove: "Confirm the approval of the ticket ?",
    },
  },
  PermissionData: {
    Title: "Permission Menu",
    Columns: {
      code: "Menu Code",
      name: "Menu Name",
      displayName: "Display Name",
      componentName: "Component Name",
      path: "Path",
      parent: "Child of ?",
      capabilities: "Capabilities",
      key: "Key",
      roles: "Applied Roles",
      users: "Applied Users",
      type: "Type",
      status: "Status",
      order: "Order",
      icon: "Menu Icon Link",
      description: "Description",
      createdAt: "Created At",
      updatedAt: "Updated At",
    },
    Detail: {
      roles: "Roles",
      users: "Users",
      capabilities: "Capabilities",
      configuration: "Configuration",
    },
    Placeholder: {
      code: "Enter menu code",
      name: "Enter menu name",
      componentName: "Enter component name",
      path: "Enter path",
    },
    Status: {
      0: "Active",
      1: "Inactive",
      2: "Deleted",
    },
  },
  UserPermission: {
    Title: "User Permission",
    Columns: {
      code: "Permission Code",
      name: "Permission Name",
      path: "Path",
      users: "Allowed Users",
      blackList: "Blacklist",
      permissionStatus: "Permission Status",
      status: "Status",
      type: "Type",
      order: "Order",
      note: "Note",
      isLog: "Write Log",
      createdAt: "Created At",
      updatedAt: "Updated At",
    },
    Detail: {
      users: "Assigned Users",
      configuration: "Configuration",
      capabilities: "Capability List",
      allowed: "Allowed",
      blocked: "Blocked",
      moveToBlackList: "Move To Blacklist",
      reAllow: "Allow Again",
    },
    Placeholder: {
      code: "Enter permission code",
      name: "Enter permission name",
      path: "Enter path",
    },
    Status: {
      0: "Active",
      1: "Inactive",
      2: "Deleted",
    },
    Type: {
      0: "For Management",
      1: "For Merchant",
      2: "For Supplier",
      3: "For Hooks",
      4: "For Auto Crawl Job",
    },
    Message: {
      NeedCreateCapa: "Code will appear after creation",
    },
  },
  RoleManagement: {
    Title: "Role Management",
    Columns: {
      code: "Role Code",
      name: "Role Name",
      status: "Status",
      order: "Order",
      maximum: "Maximum",
      level: "Level",
      users: "Users",
      menus: "Accessed Menus",
      features: "Accessed Features",
      note: "Note",
      createdAt: "Created At",
      updatedAt: "Updated At",
    },
    Detail: {
      users: "Users",
      menus: "Accessed Menus",
      features: "Accessed Features",
    },
    Placeholder: {
      code: "Enter role code...",
      name: "Enter role name...",
    },
    Status: {
      0: "Active",
      1: "Inactive",
      2: "Deleted",
    },
  },
  Capability: {
    Title: "Capability",
    Columns: {
      code: "Capability Code",
      name: "Capability Name",
      displayName: "Display Name",
      key: "Key",
      feature: "Accessed Feature",
      menus: "Accessed menus",
      status: "Status",
      order: "Order",
      description: "Description",
      note: "Note",
      createdAt: "Created At",
      updatedAt: "Updated At",
    },
    Detail: {
      configuration: "Configuration",
    },
    Placeholder: {
      code: "Enter capability code",
      name: "Enter capability name",
      key: "Enter key",
      menu: "Select menu",
    },
    Status: {
      0: "Active",
      1: "Inactive",
      2: "Deleted",
    },
    Type: {
      0: "API",
      1: "Menu",
      2: "Action",
    },
  },
  PartnerManagement: {
    Normal: "Normal",
    MainTitle: "Partner Management",
    ipnUrl: "IPN Url",
    Total: "Total Partners",
    IpConfig: "Whitelist IP",
    IsChain: {
      Chain: "Partner for Chains",
      Normal: "Affiliate Partner",
    },
    CreateUserAfter:
      "After successfully creating a partner, a user profile will be automatically created for that partner",
    UserPartner: "User Profile for the partner",
    CopyUserInfo: "The partner's user profile has been saved to the clipboard",
    Columns: {
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      type: "Type",
      status: "Status",
      isChain: "Partner Specification",
      affiliateUrl: "Affiliate Link",
      createdAt: "Created At",
    },
    Filters: {
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      isChain: "Partner Specification",
      type: "Type",
      status: "Status",
    },
    Detail: {
      createdAt: "Created At",
      updatedAt: "Updated At",
      id: "ID",
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      type: "Type",
      status: "Status",
      isChain: "Partner Specification",
      publicKey: "Public Key",
      taxCode: "Tax Code",
      whnSupplierCode: "WHN Supplier Code",
      token: "Token",
      affiliateUrl: "Affiliate Url",
      icon: "Icon Url",
      address: "Address",
      ipnUrl: "IPN Url",
    },
    Placeholder: {
      SavedPass: "Saved Password",
      SavesName: "Saved Account Name",
    },
    UserInfo: {
      createdAt: "Created At",
      name: "Name",
      fullName: "Full Name",
      userName: "Username",
      code: "Code",
      phone: "Phone Number",
      email: "Email",
      partner: "Belongs to Partner",
      type: "Type",
      status: "Status",
    },
  },
  RoamingPartner: {
    Active: {
      0: "Roaming",
    },
    Label: "Roaming Partner",
    CountryList: "Country List",
    MobileDataList: "Carrier List",
    Columns: {
      createdAt: "Created Date",
      updatedAt: "Updated Date",
      id: "Partner ID",
      code: "Partner Code",
      name: "Partner Name",
      email: "Email",
      phone: "Phone Number",
      address: "Address",
      type: "Type",
      active: "Activation Status",
      url: "Path",
      order: "Order",
    },
    Filters: {
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      type: "Type",
      active: "Activation Status",
    },
    Detail: {
      id: "ID",
      name: "Partner Name",
      code: "Partner Code",
      email: "Email",
      phone: "Phone Number",
      type: "Type",
      active: "Activation Status",
      order: "Order",
      url: "Path",
      address: "Address",
    },
  },
  AppProfileRegister: {
    Title: "Mobitopup App Contracts",
    Labels: {
      TypeContract: "User type",
      DownloadFiles: "Download contract's images",
      ApprovedBy: "Approved By",
      DetailProfile: "Profile Details",
      VerifyProfile: "Approved Profile",
      AcceptProfile: "Accept Profile",
      AcceptConfirm: "Do you want to accept this profile?",
      DenyProfile: "Reject Profile",
      DenyConfirm: "Do you want to reject this profile?",
      RejectReason: "Reject Reason",
      SignProfile: "Sign Profile",
      Id: "Profile ID",
      Status: "Status",
      Type: "Contract Type",
      Name: "Profile Name",
      Code: "Profile ID",
      Time: "Created Time",
      UpdatedTime: "Updated Time",
      ProviderCode: "Profile Identifier",
      ProviderPreviewCode: "Provider Profile ID",
      PhoneNumber: "Phone Number",
      ExpriedAt: "Contract Expiry Date",
      ExpriedSignDate: "Signing Expiry Date",
      VerifiedStatus: "Verified Status",
      IsVerified: "Verified",
      NotVerified: "Not Verified",
      File: "Document",
      SyncStatus: "Sync Profile Status",
      SyncAllStatus: "Sync All Profile Status",
      Organization: {
        Name: "Organization",
        Address: "Address",
        Email: "Email",
        TaxCode: "Tax Code",
        Bank: "Bank",
        RepresentativeName: "Representative",
        RepresentativeRole: "Position",
        BusinessCerts: "Business Registration Certificate",
      },
      Participants: {
        Title: "Participants",
        Name: "User name",
        Address: "Address",
        Email: "Email",
        TaxCode: "Tax code",
        Bank: "Bank",
        BankAccount: "Account number",
        Single: "Individual",
        Organization: "Organization",
        Code: "User code",
        RecipentCode: "Supplier user code",
        PhoneNumber: "Phone number",
        Type: "Type",
        Status: "User signed status",
        Images: "Image",
        IDNumber: "CCCD",
        IdIssueDate: "Date of issue",
        IdIssuePlace: "Place of issue",
      },
      AssetsClassify: {
        Avatar: "Profile image",
        BusinessCerts: "Business registration certificate",
        Contract: "Contract",
        IdCard: "CCCD",
        Default: "Image",
      },
      Reason: "Reason",
    },
    Messages: {
      ConfirmAcceptProfile: "Are you sure you want to approve this profile?",
      ConfirmDenyProfile: "Are you sure you want to reject this profile?",
      ConfirmSignProfile: "Are you sure you want to sign the profile?",
    },
    Status: {
      Init: "Initialization",
      Proccessing: "Waiting for signature",
      Approving: "Waiting for approval",
      Approved: "Approved",
      Completed: "Completed",
      Rejected: "Rejected",
      Cancel: "Cancelled",
      Signed: "Signed",
      Expried: "Expired",
    },
    Type: {
      Verified: "Cooperation contract",
    },
  },
  AppTransactionHistory: {
    AppPhoneRechargeTitle: "Phone top-up",
    AppSimMobifoneTitle: "SIM E-commerce",
    AppDataRegisterTitle: "Data Package",
    AppNiceSimTitle: "Nice SIM",
    AppTravelSimTitle: "Travel SIM",
    InboundTravelSimTitle: "Hello Vietnam SIM",
    OutboundTravelSimTitle: "Gogo SIM",
    ExportReportTiTle: "Export transaction history report",
    TransactionHistory: "Transaction History",
    ExportSuccess: "Export report successfully",
    Labels: {
      BuyerPhones: "Customer Phone",
      UserPhone: "User Phone",
      DetailTrans: "Transaction details",
      Status: "Status",
      Type: "Type",
      Name: "Product name",
      PackageCode: "Package code",
      SimCode: "Sim",
      Code: "Transaction code",
      ReferenceCode: "Reference code",
      Time: "Time",
      Service: "Service",
      NumberType: "Number type",
      Product: "Product",
      ProductCode: "Product code",
      IsdnOrIccid: "Phone Number/ICCID",
      ProductPrice: "Product Price",
      PhoneNumber: "Phone Number",
      SimNumber: "Number of sim",
      PaymentMethod: "Method",
      Total: "Total Amount",
      TransRef: "Reference Code",
      Platform: "Platform",
      Description: "Description",
      Nation: "Nation",
      Zodiac: "Zodiac",
      Numerology: "Numerology",
      Destiny: "Destiny",
      BeforeCredit: "Before credit",
      AfterCredit: "After credit",
      User: "Users",
      Serial: "Serial",
      CodeAirTime: "Denomination",
      MobileNumber: "Mobile Number",
      TransactionCode: "Order Code",
      SupplierRefCode: "Supplier's Transaction code",
      AmountLabel: {
        product: "Product",
        discount: "Discount",
        userTax: "Tax",
        discountRate: "Discount",
        package: "Package",
        simAdvance: "Sim retention fee",
      },
      NumberTypeOps: {
        MEMORABLE_PHYSICAL: "Noteworthy numbers",
        THREE_7_PHYSICAL: "Triple 7",
        THREE_8_PHYSICAL: "Triple 8",
        THREE_9_PHYSICAL: "Triple 9",
        AB_BA_PHYSICAL: "Pair of numbers AB_BA",
        AB_AB_PHYSICAL: "Pair of numbers AB_AB",
        AA_BB_PHYSICAL: "Pair of numbers AA_BB",
      },
      BuyerName: "Customer",
      BuyerEmail: "Email",
      BuyerPhone: "Phone Number",
      BuyerAddress: "Address",
      UserName: "Executor",
      UserCode: "User Code",
      ProductLabels: {
        SimNumber: "Sim Number",
        SimPrice: "Sim Price",
        SimType: "Sim Type",
        PackageName: "Mobile Plan",
        PackageCode: "Package Code",
        PackagePrice: "Package Price",
        Storage: "Storage quantity",
        Duration: "Duration",
        Serial: "Serial Number",
        Code: "Product Code",
        Price: "Product Price",
      },
    },
    Status: {
      Init: "Initialization",
      Process: "Processing",
      Success: "Success",
      Failed: "Failed",
      Pending: "Waiting for payment",
      PaymentSuccess: "Payment successful",
      Timeout: "Pending",
      Deleted: "Deleted",
    },
    Type: {
      Normal: "Default",
      User: "Individual",
      Partner: "Legal entity",
    },
    TransactionDetail: {
      createdAt: "Created At",
      updatedAt: "Updated At",
      name: "Transaction Name",
      code: "Transaction Code",
      transRef: "Referenced Code",
      transactionCode: "Order/Transaction Referenced Code",
      phoneNumber: "Phone Number",
      serial: "ICCID",
      status: "Status",
      totalPrice: "Total Amount",
      numberType: "Number Type",
      simType: "SIM Type",
      type: "Transaction Type",
      carrier: "Carrier",
      package: "Data Package",
      beforeCredit: "Balance Before Transaction",
      afterCredit: "Balance After Transaction",
      description: "Reason",
      buyerName: "Customer Name",
      buyerEmail: "Customer Email",
      buyerPhone: "Contact Phone Number",
      buyerAddress: "Customer Address",
      codeAirTime: "Airtime Code",
      nameAirTime: "Airtime Name",
      partnerCode: "Partner Code",
      partnerName: "Partner Name",
      userFullName: "Performer",
      userName: "Performer Name",
      userPhone: "Performer Phone Number",
    },
    RefundModal: {
      Title: "Confirmation",
      ReasonLabel: "Refund Reason",
      ReasonPlaceholder: "Enter refund reason",
      ReasonRequired: "Please enter the refund reason",
      ReasonMinLength: "Reason is too short (minimum 5 characters)",
      InfoTextPrefix: "Refund for transaction with code",
      InfoTextMiddle: "with amount",
    },
    ExportReportTransaction: {
      Title: "Export transaction report",
    },
  },
  UserAppManagement: {
    Title: "Individual users",
    BusinessTitle: "Business users",
    Verfied: "Is verified?",
    LoginSession: "Login sessions",
    AppVersion: "App version",
    LastLogin: "Last login",
    Device: "Device",
    Location: "Location",
    Label: {
      DetailInfo: "Detailed information",
      Address: "Address",
      CreatedTime: "Created Time",
      Id: "ID",
      Code: "Code",
      UserName: "Username",
      FullName: "Full Name",
      Email: "Email",
      Partner: "Partner",
      Phone: "Phone Number",
      Balance: "Balance",
      Role: "Role",
      Birthday: "Date of Birth",
      Description: "Description",
      TaxCode: "Tax Code",
      LatestContract: "Authentication Profile",
      ResetOTP: "Reset OTP",
      ChangePassword: "Change password",
      Note: "Ghi chú",
    },
  },
  TravelSimProfileRegister: {
    Title: "Travel SIM Registration",
    Status: {
      Init: "Initialization",
      InProgress: "Processing",
      Success: "Success",
      Error: "Error",
      Confirm: "Confirmed",
      Connect: "Connected",
      Approve: "Approved",
    },
    Detail: {
      Buyer: "Order Creator",
      Sim: "SIM Number",
      BuyerEmail: "Contact Email",
      BuyerPhone: "Contact Phone Number",
      BuyerCode: "Buyer Code",
      Serial: "Serial Number",
      Time: "Time",
      Title: "Transaction Details",
      Code: "Code",
      IdNumber: "Passport Number",
      Status: "Status",
      Nationality: "Nationality",
      CodeNumber: "Code",
      PlaceOfOrigin: "Place of Birth",
      IssueDate: "Date of Issue",
      IssuePlace: "Place of Issue",
      Profile: "Profile",
      ExpiryDate: "Expiry Date",
      Note: "Note",
      DialCode: "Country Code",
      Documents: "Documents",
      Front: "Front",
      Back: "Back",
      Portrait: "Portrait",
      Sign: "Signature",
      VideoCall: "Video call",
      FrontDownscale: "Front (zoom out)",
      PortraitDownscale: "Portrait (zoom out)",
      VideoCallDownscale: "Video call (zoom out)",
      Contract: "Contract",
      Policy: "Policy",
    },
    ImagePaths: {
      portrait: "Portrait",
      videocall: "Videocall",
      front: "Front",
      back: "Back",
      sign: "Signature",
      sim: "Sim",
      contractId: "Contract",
      policyId: "Privacy Policy",
      frontDownscaleId: "Front zoom",
      portraitDownscaleId: "Portrait zoom",
      videocallDownscaleId: "Video call zoom",
    },
  },
  PaymentMethod: {
    Label: "Payment Method Management",
    Total: "Total Payment Methods",
    Columns: {
      id: "Method ID",
      name: "Method Name",
      displayName: "Display Name",
      code: "Method Code",
      type: "Type",
      status: "Status",
      order: "Order",
    },
    Filters: {
      name: "Method Name",
      code: "Method Code",
      displayName: "Display Name",
      type: "Type",
      status: "Status",
    },
    Detail: {
      id: "ID",
      name: "Method Name",
      code: "Method Code",
      status: "Status",
      type: "Type",
      displayName: "Display Name",
      supplier: "Supplier",
      cover: "Image",
      description: "Description",
      url: "Path",
      order: "Order",
    },
    Active: {
      1: "Bank",
      2: "E-wallet",
    },
  },
  SupplierManagement: {
    Label: "Supplier Management",
    Total: "Total Suppliers",
    Code: "Supplier Package Code",
    Columns: {
      id: "Supplier ID",
      name: "Supplier Name",
      displayName: "Display Name",
      email: "Email",
      phoneNumber: "Phone Number",
      address: "Address",
      type: "Type",
      status: "Status",
    },
    Filters: {
      name: "Supplier Name",
      displayName: "Display Name",
      email: "Email",
      phoneNumber: "Phone Number",
      type: "Type",
      status: "Status",
    },
    Detail: {
      id: "ID",
      name: "Supplier Name",
      status: "Status",
      type: "Type",
      displayName: "Display Name",
      email: "Email",
      phoneNumber: "Phone Number",
      address: "Address",
      cover: "Image",
      image: "Image",
      description: "Description",
      order: "Order",
    },
    Active: {
      0: "Default",
      1: "Payment",
      2: "OCR",
    },
  },
  AirTimeManagement: {
    Label: "Manage phone top-up denominations",
    Total: "Total phone top-up denominations",
    Columns: {
      id: "Denomination ID",
      name: "Denomination Name",
      code: "Denomination Code",
      amount: "Denomination Value (VND)",
      type: "Type",
      status: "Status",
    },
    Filters: {
      name: "Denomination Name",
      code: "Denomination Code",
      amount: "Denomination Value",
      carrier: "Carrier",
      type: "Type",
      status: "Status",
    },
    Detail: {
      name: "Denomination Name",
      code: "Denomination Code",
      amount: "Denomination Value",
      status: "Status",
      type: "Type",
      carrier: "Carrier",
      config: "Configuration",
      description: "Description",
    },
    Supplier: {
      name: "Supplier Name",
      displayName: "Display Name",
      address: "Address",
      email: "Email",
      phoneNumber: "Phone Number",
      description: "Description",
    },
    Type: {
      0: "Phone Card",
    },
    Message: {
      name: "Enter the name...",
      code: "Enter the code...",
      amount: "Enter the value at least 1,000 VND",
      status: "Select the status...",
      type: "Select the type...",
      carrier: "Select the carrier...",
      config: "Enter the config...",
      description: "Enter the description...",
    },
  },
  DiscountManagement: {
    Title: "Discount",
    CreateDiscount: "Create Discount",
    UpdateDiscount: "Update Discount",
    Columns: {
      id: "ID",
      createdAt: "Created Date",
      updatedAt: "Updated Date",
      name: "Discount Name",
      code: "Discount Code",
      type: "Discount Type",
      order: "Order",
      note: "Note",
      discountRate: "Discount",
      parentId: "Belongs to discount group",
      service: "Service",
      group: "Product group",
      product: "Product",
      parent: "Parent discount",
      child: "Child discount",
      parentCode: "Parent discount code",
      parentRate: "Parent discount rate",
      AddNewUser: "Add user",
    },
    Filters: {
      status: "Status",
      type: "Type",
      user: "User",
      service: "Service",
      group: "Product group",
    },
    Messages: {
      Required: "Please fill in this information",
      DeleteConfirm: 'Do you want to delete "{name}"?',
    },
  },
  SimManagement: {
    Title: "Sim Management",
    DownloadTemplate: "Download sim import form",
    UploadFile: "Upload sim import form",
    ImportSim: "Import sim",
    ImportTable: "Import sim directly",
    ImportFile: "Import sim from file",
    ImportSuccess: "Import sim successfully",
    AddRow: "Add row",
    QuickUpdate: "Do you want to update quickly?",
    ErrorMessage1: "The form you just imported is available",
    ErrorMessage2: "Error row",
    SimDetail: "Sim information",
    Status: {
      Active: "Available",
      Inactive: "Unavailable",
      Sold: "Sold",
      Deleted: "Deleted",
    },
    SimType: {
      Physical: "Physical SIM",
      ESim: "eSIM",
    },
    Fields: {
      Code: "Identifier",
      Name: "Display name",
      Serial: "Serial",
      PhoneNumber: "Sim Number",
      Status: "Status",
      Type: "Service",
      SimType: "Sim Type",
      SKU: "SKU Code",
      Zodiac: "Zodiac Sign",
      Numerology: "Numerology",
      Destiny: "Destiny",
      Description: "Description",
      ShortDescription: "Short Description",
    },
  },
  AppFeedback: {
    Title: "Support Request",
    Detail: "Request detail",
    Labels: {
      Code: "Code",
      Phone: "Phone",
      OS: "OS",
      Device: "Device",
      AppVersion: "App version",
      AppCode: "App code",
      CreatedAt: "Created At",
      Description: "Description",
      Note: "Note",
      File: "File",
      Logs: "Logs",
      User: "User",
    },
  },
  SupportFeature: {
    MainTitle: "Support",
    PackageLookup: {
      Title: "Mobile Plan Lookup",
      Input: {
        Placeholder: "Enter subscriber number",
      },
      Output: {
        StartDate: "Activation Date",
        EndDate: "End Date",
        Capacity: "Capacity",
        UsedCapacity: "Used Capacity",
        RemaingCapacity: "Remaining Capacity",
        Package: "Package Name",
        PackageCapacity: "Package Capacity",
        NotFound: "This phone number has not been registered any packages",
      },
    },
    SimLookup: {
      Title: "SIM Lookup",
      Input: {
        Placeholder: "Enter subscriber number/ICCID",
        QRCode: "SIM QRCode",
      },
      Output: {
        isActivated: "SIM has been activated",
        isUnactivated: "SIM has not been activated",
        isNotExist: "This phone number/ICCID does not exist",
      },
      Message: {
        NumberOrQr:
          "Please enter the phone number/ICCID or upload the SIM QR code image.",
      },
    },
    ApiDoc: {
      Title: "API Documentation",
    },
    Dispatch: {
      Title: "Official Dispatch",
    },
  },
  CashFlow: {
    MainTitle: "Cash Flow",
    Columns: {
      TransCode: "Transaction Code",
      CostIn: "Cash Inflow",
      CostOut: "Cash Outflow",
      Wallet: "Closing Balance",
      Content: "Transfer Details",
      Total: " Total Amount",
    },
    Filters: {
      Type: "Content",
      Code: "Transaction code",
      Debit: "Disbursement",
      Withdraw: "Cash Outflow",
      Deposit: "Deposit",
      Refund: "Refund",
    },
    Type: {
      0: "Debit",
      1: "Withdraw",
      2: "Deposit",
      3: "Refund",
    },
  },
  StaffManagement: {
    Title: "Account Management",
    MainTitle: "User Management",
  },
  StoreManagement: {
    Title: "Stores",
    Labels: {
      Code: "Code",
      Phone: "Phone",
      Chain: "Chain",
      Status: "Status",
      Name: "Store name",
      Email: "Email",
      Description: "Description",
      Balance: "Balance",
      Note: "Note",
      Address: "Address",
      StoreHeader: "Store header",
      StoreHeaderPhone: "Store header phone",
      UsersInStore: "Users in store",
    },
    Messages: {
      DeleteConfirm: 'Do you want to delete "{name}" store?',
    },
  },
  ErrorCodeManagement: {
    Title: "Error Code Management",
    Columns: {
      name: "Error Name",
      code: "Error Code",
      source: "Source",
      service: "Service",
      message: "Brief Content",
      description: "Full Content",
      type: "Type",
      status: "Status",
      createdAt: "Created Date",
    },
    Detail: {
      createdAt: "Created Date",
      updatedAt: "Updated Date",
      name: "Error Code Name",
      code: "Error Code",
      source: "Source",
      service: "Service",
      message: "Brief Content",
      description: "Full Content",
      note: "Description",
      order: "Order",
      type: "Type",
      status: "Status",
    },
    Filters: {
      code: "Error Code",
      message: "Brief Content",
      description: "Full Content",
      source: "Source",
      note: "Description",
      type: "Type",
      status: "Status",
    },
    ErrorType: {
      0: "Missing Input",
      1: "Invalid Input",
      2: "Business Logic Error",
      3: "Authentication/Authorization Error",
      4: "Server/Network Error",
      5: "Configuration Error",
      6: "Code logic Error",
    },
    Source: ["SMM", "B2C", "B2B", "Neci"],
  },
  B2BAccount: {
    Title: "B2B accounts",
    Labels: {
      Phone: "Phone",
      Partner: "Partner",
      Status: "Status",
      Name: "Name",
      Username: "Username",
      Email: "Email",
      Description: "Description",
      Balance: "Balance",
      Note: "Note",
      Address: "Address",
    },
  },
  B2BPartner: {
    Title: "B2B partners",
    Labels: {
      Name: "Name",
      DisplayName: "Display name",
      Code: "Code",
      Status: "Status",
      Description: "Description",
      Balance: "Balance",
      Address: "Address",
      Website: "Website",
    },
  },
  B2BPackageManagement: {
    TotalTitle: "Total number of packages",
    SupplierCode: "Supplier information",
    Setting: "Settings",
    MainTitle: "Package list",
    MerchantInventoryLabel: "Partner inventory",
    AddNewPackage: "Add new package",
    DeletePackageConfirm: "Do you want to delete this package?",
    DetailModalTitle: "Package details",
    AddNewModalTitle: "Add new package",
    AddNewDescription: "Add description",
    SMS: "SMS Top-up",
    Direct: "Direct Top-up",
    InventoryType: "Inventory Type",
    HighPriority: "High Priority",
    LowPriority: "Low Priority",
    Channel: {
      Title: "Channel",
      TTC: "Billing Center",
    },
    Titles: {
      IndexNumber: "No.",
      PackageCode: "Package Code",
      PackageName: "Package Name",
      Type: "Type",
      Group: "Package Group",
      DurationDay: "Package Duration (days)",
      Price: "Price",
      MinPrice: "Minimum Price",
      MaxPrice: "Maximum Price",
      Status: "Status",
      Action: "Action",
      Supplier: "Supplier",
      SupplierCode: "Supplier Reference Code",
      Description: "Description",
      Discount: "Discount",
      OnlyData: "Only Data?",
      JustData: "Data Only",
      DataAndCall: "Data & Voice",
      Image: "Package Image",
      ImagePlaceholder: "Enter image link",
      TopUpMethod: "Top-up Method",
      RemoveDescription: "Remove Description",
      Inventories: "Inventories",
    },
    Details: {
      createdAt: "Created At",
      updatedAt: "Updated At",
      id: "Package ID",
      name: "Package Name",
      code: "Package Code",
      durationDay: "Duration",
      price: "Package Price (VND)",
      topupMethod: "Top-up Method",
      discountRate: "Discount Rate",
      type: "Type",
      status: "Status",
      mobileDataGroup: "Package Group",
    },
    MerchantInventory: {
      createdAt: "Created At",
      updatedAt: "Updated At",
      id: "ID",
      name: "Name",
      code: "Code",
      balance: "Quota",
      maxBalance: "Maximum Quota",
      type: "Type",
      status: "Status",
      merchant: "Partner",
    },
    SupplierCodes: {
      id: "ID",
      order: "Priority",
      type: "Channel",
      status: "Status",
      supplier: "Supplier",
      merchantInventory: "Inventory Information",
    },
    Messages: {
      AtLeastOneDescription: "At least one description is required!",
      TopupMethodSectionMessage: "Please select a top-up method",
      GroupSelectionMessage: "Please select a package group!",
      TypeSelectionMessage: "Please select a package type!",
      StatusSelectionMessage: "Please select a package status!",
      ImageMessage:
        "Please enter an image link (http://) ending with png, jpg, or jpeg",
      ImageError:
        "The link you entered is not a valid image link. Please try again!",
      Price: "Please select a price of at least 1,000 VND",
      SetPrioritySuccess: "Priority updated successfully",
      SetPriorityFailed: "Failed to update priority",
      DeleteInventoryConfirm: "Do you want to delete all selected inventories?",
      AddPackageConfirm: "Do you want to exit the package creation process?",
      SelectSupplierMessage:
        "Please select a supplier before adding inventories.",
      InventoriesRequired: "Please add inventories",
      OnlyForWarehouse:
        "This feature is only available for suppliers of type 'Warehouse'",
      ChangeSupplier: "Change supplier",
      ClearInventories:
        "Note: Changing the supplier will remove all added inventories.",
      DurationDay: "Enter the day at least from 1 day",
    },
    TopupMethodList: {
      Live: "Live",
      SMS: "SMS",
    },
    StatusList: {
      Actived: "Active",
      Deactived: "Inactive",
      Deleted: "Deleted",
    },
    TypeList: {
      Normal: "Normal",
      Flexible: "Flexible",
      Hourly: "Hourly",
      Roaming: "Roaming",
    },
    DurationDayList: {
      "1_Day": "1 day",
      "3_Days": "3 days",
      "7_Days": "7 days",
      "10_Days": "10 days",
      "15_Days": "15 days",
      "30_Days": "30 days",
    },
    Inventories: {
      AddInventory: "Add inventory",
      EditInventory: "Edit inventory",
      ManualAddition: "Manual",
      FindFromWarehouse: "From Warehouse",
      Excel: "Excel file",
    },
    InventoryColumns: {
      Code: "Inventory Code",
      Name: "Inventory Name",
      SKU: "SKU",
      Merchant: "Partner",
      Balance: "Quota",
      MaxBalance: "Maximum Quota",
      Status: "Status",
      Type: "Type",
      Order: "Priority",
      Channel: "Channel",
      Method: "Addition Method",
    },
    InventoryStatusList: {
      Active: "Active",
      Deactive: "Inactive",
    },
    InventoryChannelList: {
      WH3: "Warehouse 3",
      WHN: "Warehouse New",
    },
    InventoryOrderList: {
      High: "High",
      Low: "Low",
    },
    InventoryTypeList: {
      Normal: "Normal",
    },
  },
  OscLookupFeature: {
    SubTitle: "IoT SIM Support",
    Title: "Subscriber Lookup",
    Searching: "Searching for subscriber info",
    EmptyResult:
      "Enter Phone Number/Serial and click 'Search' to reveal information",
    Labels: {
      phoneNumber: "Phone Number",
      serial: "Serial",
      status: "Activation Status",
      subscriberStatus: "Subscriber Status",
      isdnType: "Subscriber Type",
      simType: "SIM Type",
      device: "Device",
      imei: "International Mobile Equipment Identity (IMEI)",
      packageName: "Package Name",
      startDate: "Registration Date",
      endDate: "Expiry Date",
      serviceName: "Service Name",
      total: "Total Data",
      dataUsed: "Used Data",
      remaining: "Remaining Data",
    },
    Status: {
      Activated: "Activated",
      NotActivated: "Not Activated",
      Active: "Active",
      Inactive: "Inactive",
    },
    Types: {
      Prepaid: "Prepaid",
      Postpaid: "Postpaid",
      PhysicalSim: "Physical SIM",
      ESim: "eSIM",
    },
    Messages: {
      LookupSuccessfully: "Lookup Successfully",
      LookupFailed: "The phone number/serial is not valid or does not exist",
      PhoneNumber: "Fill in the phone number...",
      Serial: "Fill in the Serial number...",
    },
  },
  IOTSimListLookup: {
    Title: "Sim List Lookup",
    MainTitle: "IoT Sim Support",
    Labels: {
      Search: "Search",
      ExportExcel: "Export Excel",
    },
    Messages: {
      ExportSuccess: "Export Excel Success",
      NoDataToExport: "No data to export",
      PleaseSelectFile: "Please select an Excel file to search",
    },
    Uploader: {
      FolderIncoming: "Excel folder being imported",
      ChooseAnother: "Choose another file",
      DragDropHint: "Drag and drop your Excel file anywhere here",
      Or: "Or",
      ChooseFile: "Choose a file",
      DropHere: "Drop Excel file here",
      DownloadTemplate: "Download template",
    },
    Status: {
      Active: "Active",
      Inactive: "Inactive",
    },
    SubscriberStatus: {
      Active: "Active",
      InActive: "Inactive",
    },
    IsdnType: {
      Prepaid: "Prepaid",
      Postpaid: "Postpaid",
    },
    SimType: {
      SIM: "Physical SIM",
      eSIM: "eSIM",
    },
    Columns: {
      PhoneNumber: "Phone number",
      Serial: "Sim Serial",
      SubscriberStatus: "Subscriber Status",
      PackageName: "Package Name",
      StartDate: "Registration Date",
      EndDate: "Expiration Date",
      TotalData: "Total Capacity",
      DataUsed: "Data Used",
      DataRemaining: "Data Remaining",
      Device: "Device used",
      ActivationStatus: "Activation Status",
      IsdnType: "ISDN Type",
      SimType: "Sim Type",
    },
  },
  ActionLog: {
    Columns: {
      createdAt: "Created At",
      updatedAt: "Updated At",
      name: "Name",
      code: "Code",
      type: "Type",
      status: "Status",
      note: "Note",
      order: "Order",
      path: "Path",
      user: "User",
    },
    Status: {
      Active: "Active",
      InActive: "InActive",
      Deleted: "Deleted",
    },
    Types: {
      0: "Normal",
    },
    Filters: {
      search: "Search",
      status: "Status",
      type: "Type",
      path: "Path",
      user: "Performed By",
    },
    Placeholders: {
      search: "Enter keyword (name, code)...",
      status: "Select status...",
      type: "Select type...",
      path: "Enter path...",
      user: "Select user...",
    },
    Users: {
      username: "Username",
      name: "Name",
      code: "Code",
      type: "Type",
      status: "Status",
    },
  },
  AlertSupport: {
    SubTitle: "IoT SIM Support",
    Title: "Alert",
    LoadingTitle: "Loading alert list",
    TotalTitle: "Total",
    Detail: {
      Title: "Alert Detail",
    },
    Filters: {
      RemainingDays: {
        Title: "By Remaining Days",
        Description:
          "Send notifications when the remaining package days reach the following milestones:",
        Unit: " days",
      },

      RemainingCapacity: {
        Title: "Remaining Data Capacity Alert",
        Description:
          "Send notifications when the remaining package capacity reaches the following thresholds:",
        Unit: "%",
      },
    },
    Columns: {
      phoneNumber: "Phone Number",
      numberOfDaysRemainingUntilExpiration: "Remaining Expiry Days",
      capacity: "Package Capacity",
      remainingCapacity: "Remaining Capacity",
      remainingPercentageCapacity: "Remaining Capacity Percentage",
    },
  },
};
